/* eslint-disable-next-line @github-ui/github-monorepo/no-use-app-payload --
   useAppPayload is deprecated. See
   https://thehub.github.com/epd/engineering/dev-practicals/frontend/react/data-router/migration/app-payload-deprecation/ */
import {useAppPayload} from '@github-ui/react-core/use-app-payload'

export interface CommitsAppPayload {
  helpUrl: string
  findFileWorkerPath: string
  findInFileWorkerPath: string
  findInDiffWorkerPath: string
  githubDevUrl: string
}

export function useCommitsAppPayload() {
  return useAppPayload<CommitsAppPayload>()
}
